let lastId = null;

export function shouldMock(id) {
  if (typeof window === 'undefined') return false;
  if (typeof window.optiUser === 'undefined') return false;

  const decision = window.optiUser.decide('lookletvideo', ['DISABLE_DECISION_EVENT']);

  const products = decision?.variables?.products || {};
  const product = products[id];
  if (product) {
    // We trigger again to 1) log the decision event and 2) to get the user into the experiment
    if (lastId !== id) {
      window.optiUser.decide('lookletvideo');
      lastId = id;
    }

    if (decision?.variationKey === 'expb') {
      return {
        ...product,
        onShow() {
          window.optiUser.trackEvent('showlookletvideo', product);
        },
      };
    }
  }

  lastId = id;
  return window?.mockedProducts?.[id] || false;
}
